<div class="issues-filters">
  <div class="issues-filters-row">
    <app-search-box
      class="filters-search"
      (textOnSelection)="searchSubmitted($event)"
      [placeholder]="'issuesPage.filters.search' | labelsProvider"
      [startingValue]="pageFilters.search.getFilterValue()"
      [newValueTriggered$]="searchBoxNewValue"
      [syncValidators]="searchValidators"
    >
    </app-search-box>
    <app-date-time-picker
      class="filters-date-time-picker"
      (dateOnSelection)="firstSeenFromDateSelected($event)"
      label="tableActionsAndFilters.timestampSinceDate"
      [startingValue]="pageFilters.firstSeenFromDate.getFilterValue()"
      [newValueTriggered$]="firstSeenFromDateNewValue"
      [minDate]="minDate"
      [maxDate]="pageFilters.firstSeenToDate.getFilterValue()"
    >
    </app-date-time-picker>
    <app-date-time-picker
      class="filters-date-time-picker"
      (dateOnSelection)="firstSeenToDateSelected($event)"
      label="tableActionsAndFilters.timestampUntilDate"
      [startingValue]="pageFilters.firstSeenToDate.getFilterValue()"
      [newValueTriggered$]="firstSeenToDateNewValue"
      [minDate]="pageFilters.firstSeenFromDate.getFilterValue()"
    >
    </app-date-time-picker>
  </div>
  <app-view-filters-multi-select [pageFilters]="pageFilters"></app-view-filters-multi-select>
</div>
